import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00e5192e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay background-gradient" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_Uploader = _resolveComponent("Uploader")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: "Edit Profile",
      backLink: _ctx.PROFILE_ROUTE
    }, null, 8, ["backLink"]),
    _createVNode(_component_van_form, { class: "container" }, {
      default: _withCtx(() => [
        _createVNode(_component_Uploader, {
          modelValue: _ctx.fileList,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event)),
          "max-count": 1,
          "preview-size": 150
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_image, {
              height: "150px",
              width: "150px",
              src: `data:image/png;base64,${_ctx.self.avatar}`,
              round: "",
              fit: "cover"
            }, null, 8, ["src"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          modelValue: _ctx.displayName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.displayName) = $event)),
          name: "Display name",
          label: "Name",
          placeholder: "Enter your name",
          rules: [_ctx.charCountValidator]
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_button, {
          round: "",
          type: "primary",
          onClick: _ctx.editProfile
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    })
  ]))
}